import { render, staticRenderFns } from "./dcPxWjStduyList.vue?vue&type=template&id=ca9a8b3e&scoped=true&"
import script from "./dcPxWjStduyList.vue?vue&type=script&lang=js&"
export * from "./dcPxWjStduyList.vue?vue&type=script&lang=js&"
import style0 from "./dcPxWjStduyList.vue?vue&type=style&index=0&id=ca9a8b3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9a8b3e",
  null
  
)

export default component.exports